module.exports = __webpack_public_path__ + "static/media/lego-head-404.82293924.svg";